import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { TranscriptionsComponent } from '../transcriptions/transcriptions.component';
import { SplitterModule } from 'primeng/splitter';
import { ConversationDataComponent } from '../conversation-data/conversation-data.component';
import { AsyncPipe, NgClass, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { ConversationIdsComponent } from './components/conversation-ids/conversation-ids.component';
import { combineLatest, map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { APPLICATION_REDUCER, IApplicationState } from '../../store/reducers/application.reducer';
import { RouterOutlet } from '@angular/router';
import { ConversationMobileViewComponent } from './components/conversation-mobile-view/conversation-mobile-view.component';
import { EScreenSizeBreakPoint, EViewMode } from '../../core/configurations/application';
import { QueryNavigationComponent } from '../../shared/components/query-navigation/query-navigation.component';
import { ApplicationService } from '../../core/services/application.service';
import { conversationSlideInAndOutAnimation } from './configurations/conversation-animations.config';

@Component({
  selector: 'cv-conversation',
  standalone: true,
  imports: [
    TranscriptionsComponent,
    ConversationDataComponent,
    SplitterModule,
    NgOptimizedImage,
    ConversationIdsComponent,
    AsyncPipe,
    RouterOutlet,
    ConversationMobileViewComponent,
    QueryNavigationComponent,
    NgClass,
    NgTemplateOutlet,
  ],
  templateUrl: './conversation.component.html',
  styleUrl: './conversation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [conversationSlideInAndOutAnimation],
})
export class ConversationComponent {
  readonly data$: Observable<IConversationComponentData> = combineLatest({
    applicationState: this.store.select<IApplicationState>(APPLICATION_REDUCER.selectApplicationState),
    isNavShown: this.applicationService.queryDataIds$.pipe(map((ids) => ids?.length > 1)),
    isScreenLarge: this.store.select(APPLICATION_REDUCER.isScreenSizeBreakpoint(EScreenSizeBreakPoint.lg)),
    isReviewMode: this.store.select(APPLICATION_REDUCER.isViewMode(EViewMode.scoreChallengeReview)),
  });
  constructor(
    private readonly store: Store,
    private readonly applicationService: ApplicationService,
  ) {}
}

interface IConversationComponentData {
  applicationState: IApplicationState;
  isNavShown: boolean;
  isScreenLarge: boolean;
  isReviewMode: boolean;
}
